import React, { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { doc, getDoc } from 'firebase/firestore'
import { db } from './firebase/config'
import Login from './pages/Login'
import RoleSelection from './pages/RoleSelection'
import Dashboard from './pages/Dashboard'
import TeacherDashboard from './pages/TeacherDashboard'
import LoadingScreen from './components/LoadingScreen'
import './App.css'

function App() {
  const { user, loading } = useAuth()
  const [userData, setUserData] = useState(null)
  const [userLoading, setUserLoading] = useState(true)

  useEffect(() => {
    if (user && !userData) {
      loadUserData()
    } else if (!user) {
      setUserData(null) // Clear user data if user logs out
      setUserLoading(false)
      
      // Kullanıcı çıkış yaptığında hash'i temizle
      if (window.location.hash) {
        window.location.hash = ''
        window.history.replaceState(null, '', window.location.pathname)
      }
    }
  }, [user, userData])

  const loadUserData = async () => {
    try {
      const userDoc = await getDoc(doc(db, 'users', user.uid))
      if (userDoc.exists()) {
        setUserData(userDoc.data())
      } else {
        setUserData(null) // User exists in auth but not in Firestore, needs role selection
      }
      setUserLoading(false)
    } catch (error) {
      console.error('Error loading user data:', error)
      setUserLoading(false)
    }
  }

  const handleRoleComplete = (data) => {
    setUserData(data)
  }

  if (loading || userLoading) {
    return <LoadingScreen />
  }

  return (
    <div className="App">
      <Routes>
        {user ? (
          // Kullanıcı giriş yapmışsa
          userData ? (
            // Kullanıcı verisi varsa (rol seçimi tamamlanmışsa)
            userData.role === 'teacher' ? (
              // Öğretmen rolünde ise direkt öğretmen dashboard'ına yönlendir
              <Route path="/*" element={<TeacherDashboard userData={userData} onBack={() => {}} />} />
            ) : (
              // Öğrenci rolünde ise ana dashboard'a yönlendir
              <Route path="/*" element={<Dashboard userData={userData} />} />
            )
          ) : (
            // Kullanıcı verisi yoksa (rol seçimi gerekiyor)
            <Route path="/*" element={<RoleSelection onComplete={handleRoleComplete} />} />
          )
        ) : (
          // Kullanıcı giriş yapmamışsa
          <Route path="/*" element={<Login />} />
        )}
      </Routes>
    </div>
  )
}

export default App
